import type { IconSvgObject } from './types';

const PropertyNewIcon: IconSvgObject = [
  ["path", { d: "M3 8H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 16.5H17M7 16.5H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 12.5H17M7 12.5H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 4.99991V18.9999C3 20.1045 3.89543 20.9999 5 20.9999L19 20.9999C20.1046 20.9999 21 20.1045 21 18.9999V4.99991C21 3.89534 20.1046 2.99991 19 2.99991H5C3.89543 2.99991 3 3.89534 3 4.99991Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PropertyNewIcon;
